"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-3082f8e4"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "upload-btn icon icon-files" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("span", _hoisted_1, [
        (!_ctx.isMute)
            ? (vue_1.openBlock(), vue_1.createElementBlock("input", {
                key: 0,
                title: "文件",
                type: "file",
                "data-type": "file",
                accept: "*",
                onChange: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return (_ctx.sendUploadMessage && _ctx.sendUploadMessage.apply(_ctx, args));
                    })
            }, null, 32))
            : vue_1.createCommentVNode("", true),
        vue_1.renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]));
}
exports.render = render;
